var _path, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "expand_icon",
    "data-name": "expand icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.469,
    height: 12.234,
    viewBox: "0 0 27.469 12.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M42.116,45.934c-.181,0-.272-.091-.453-.181a.676.676,0,0,1,0-.816h0l4.984-4.622H38.059V39.228h8.679l-4.984-4.712.725-.816,5.891,5.619c.091.091.181.181.181.272v.181h0c0,.181-.091.272-.181.453l-5.981,5.619C42.387,45.934,42.206,45.934,42.116,45.934Z",
    transform: "translate(-21.081 -33.7)",
    fill: "#a2a2a2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_316",
    "data-name": "Line 316",
    x2: 14.434,
    transform: "translate(0 1.001)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    x2: 14.434,
    transform: "translate(0 6.001)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_318",
    "data-name": "Line 318",
    x2: 14.434,
    transform: "translate(0 11.001)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.cf71d3cb3a80a4d4ffd0da442b0fa327.svg";
export { ForwardRef as ReactComponent };